<div id="onboarding-summary-page">

  <app-onboarding-stepper [currentStep]="4"></app-onboarding-stepper>
  <app-onboarding-header
    [title]="'Étape 4 : ' + (!isPaying ? 'Récapitulatif' : 'Paiement')"
    content="Veuillez vérifier les informations ci-dessous avant de continuer et procéder au paiement.">
  </app-onboarding-header>

  <app-onboarding-coupon-form (couponSelected)="updateCoupon = $event"></app-onboarding-coupon-form>
  <app-onboarding-summary [subscription]="subscriptionData" [showAllInfo]="isPaying" [coupon]="coupon"></app-onboarding-summary>

  <div class="container-payment-selector container-payment" [hidden]="!isPaying || isPaymentProcessing">
    <div class="summary-subtitle">Informations de paiement</div>
    <div class="container-payment-item" (click)="currentPaymentMethod = 'card'"
         [class.selected]="currentPaymentMethod === 'card'">
      <div class="label-option">
        Carte de crédit
        <div class="payment-method-logo">
          <img ngSrc="assets/images/icons/visa.svg" alt="" width="78" height="32">
          <img ngSrc="assets/images/icons/mastercard.svg" alt="" width="78" height="32">
        </div>
      </div>
    </div>
    <div class="payment-method" [class.selected]="currentPaymentMethod === 'card'">
      <div id="card-element">
        <!-- Stripe Card Element will be inserted here -->
      </div>
    </div>
    <div class="container-payment-item" (click)="currentPaymentMethod = 'sepa'"
         [class.selected]="currentPaymentMethod === 'sepa'">
      <div class="label-option">
        Prélèvement bancaire
        <div class="payment-method-logo">
          <img ngSrc="assets/images/icons/sepa.svg" alt="" width="78" height="32">
        </div>
      </div>
    </div>
    <div class="payment-method" [class.selected]="currentPaymentMethod === 'sepa'">
      <div id="sepa-element">
        <!-- Stripe Card Element will be inserted here -->
      </div>
    </div>
  </div>

  <div class="container-processing-payment" [hidden]="!isPaymentProcessing">
    <div class="summary-subtitle">Vérification du paiement</div>

    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <div>Validation du paiement en cours...</div>
    </div>

  </div>

  <div class="container-actions">
    <button mat-stroked-button (click)="previousStep()"
            class="base"
            type="button" [disabled]="isPaymentProcessing">
      Retour
    </button>
    <button mat-flat-button (click)="!isPaying ? showPayment() : submitPayment()"
            color="accent"
            type="submit" [disabled]="isPaymentProcessing">
      <div class="icon">
        <img ngSrc="assets/images/icons/white/credit-card.svg" alt="Icon credit card" width="24" height="24">
        Payer
      </div>
    </button>
  </div>
</div>
